const translations = {
  "en": {
    "Alert": "Alert",
    "Critical": "Critical",
    "Details": "Details",
    "Important": "Important",
    "Today": "Today"
  },
  "zh-tw": {
    "Alert": "提醒",
    "Critical": "關鍵",
    "Details": "細節",
    "Important": "重要",
    "Today": "今天"
  }
};

export default translations;
